import { render, staticRenderFns } from "./FinanceDetails.vue?vue&type=template&id=10423bc5&"
import script from "./FinanceDetails.vue?vue&type=script&lang=js&"
export * from "./FinanceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports